import axios from 'axios';

const api = axios.create({
  baseURL: process.env.API,
  headers: {
    'Content-Type': 'application/json'
  }
});

const api2 = axios.create({
  baseURL: process.env.API2,
  withCredentials: true,
 // xsrfCookieName: 'XSRF-TOKEN', // ชื่อ Cookie ที่ Laravel ส่งมาให้
 // xsrfHeaderName: 'X-XSRF-TOKEN', // ชื่อ Header ที่ Laravel รอตรวจ
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
   // 'X-Requested-With': 'XMLHttpRequest'
  }
});

const apiNoCre = axios.create({
  baseURL: process.env.API2,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
  }
});

const apiUpload = axios.create({
  baseURL: process.env.API2,
  withCredentials: true,
 // xsrfCookieName: 'XSRF-TOKEN', // ชื่อ Cookie ที่ Laravel ส่งมาให้
 // xsrfHeaderName: 'X-XSRF-TOKEN', // ชื่อ Header ที่ Laravel รอตรวจ
  // headers: {
  //   'X-Requested-With': 'XMLHttpRequest'
  // }
});

api2.interceptors.request.use((config) => {

  const token = localStorage.getItem('token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api2.interceptors.response.use(
  (response) => response,

  async (error) => {

    const originalRequest = error.config;

    if (
       error.response && error.response.status === 401 &&
      !originalRequest._retry
    ) {

      originalRequest._retry = true;

      try {

          const refreshToken =  localStorage.getItem('refresh_token');

        const response = await axios.post(
          `${process.env.API2}/auth/refresh/${refreshToken}`,
           {},
          {
            withCredentials: true
          }
        );

        const newToken = response.data.token;

        localStorage.setItem('token', newToken);

        originalRequest.headers.Authorization =
          `Bearer ${newToken}`;

        return api2(originalRequest);

      } catch (refreshError) {

        localStorage.removeItem('token');
        localStorage.removeItem('refresh_token');

        window.location.href = '/login';

        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

apiUpload.interceptors.request.use((config) => {

  const token = localStorage.getItem('token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

apiUpload.interceptors.response.use(
  (response) => response,

  async (error) => {

    const originalRequest = error.config;

    if (
      error.response && error.response.status === 401 &&
      !originalRequest._retry
    ) {

      originalRequest._retry = true;

      try {

       const refreshToken = localStorage.getItem('refresh_token');

        const response = await axios.post(
          `${process.env.API2}/auth/refresh/${refreshToken}`,
          {},
        {
           withCredentials: true
        }
        );

        const newToken = response.data.token;

        localStorage.setItem('token', newToken);

        originalRequest.headers.Authorization =
          `Bearer ${newToken}`;

        return apiUpload(originalRequest);

      } catch (refreshError) {

        localStorage.removeItem('token');
        localStorage.removeItem('refresh_token');

        window.location.href = '/login';

        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export {api, api2, apiNoCre, apiUpload };


// WEBPACK FOOTER //
// ./src/service/ApiService.js